const LINK_TOKEN_PARAM = 't';

declare global {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	interface Window {
		__LB_LINK_TOKEN__?: string;
	}
}

/**
 * The token a link from the Hub carries in its fragment (`#t=`), e.g. the Debt Schedule link. It is
 * a credential, so it must leave the address bar before anything reports the page URL. The inline
 * script at the top of `public/index.html` does that ahead of the Meta Pixel and GTM snippets and
 * hands the token over on `window`; reading the URL here covers a page served without that script.
 * `index.tsx` imports this module before the app, and so before PostHog starts.
 */
const takeLinkToken = (): string | undefined => {
	if (typeof window === 'undefined') return undefined;
	const handedOver = window.__LB_LINK_TOKEN__;
	delete window.__LB_LINK_TOKEN__;
	if (handedOver) return handedOver;
	if (!window.location.hash) return undefined;
	const token = new URLSearchParams(window.location.hash.slice(1)).get(LINK_TOKEN_PARAM);
	if (!token) return undefined;
	const { pathname, search } = window.location;
	window.history.replaceState(window.history.state, '', pathname + search);
	return token;
};

const linkToken = takeLinkToken();

/** The token of the link this page was opened with, if it carried one. */
export const getLinkToken = (): string | undefined => linkToken;
